import UserModel from 'Models/UserModel';
import BoosterProfileModel from 'Models/BoosterProfileModel';

export default function booster(store) {
  function getUserInfo() {
    let { user } = store.state;
    if (window.user) {
      user = window.user;
    }

    const isBooster = user && [UserModel.ROLES.PRO.id, UserModel.ROLES.PRO_CANDIDATE.id].includes(+user.role);
    const boosterProfile = isBooster ? user.booster_profile : null;

    return {
      user,
      isBooster,
      boosterProfile,
    };
  }

  return [
    {
      path: '/booster*',
      redirect: (to) => to.path.replace('booster', 'pro'),
    },
    {
      name: 'booster',
      path: '/pro',
      meta: {
        authorizedOnly: true,
      },
      beforeEnter(to, from, next) {
        const { boosterProfile, isBooster } = getUserInfo();
        if (!isBooster) {
          next('/');
          return;
        }

        if ([BoosterProfileModel.STATUSES.DECLINED.id, BoosterProfileModel.STATUSES.REVISION.id]
          .includes(boosterProfile.status_id)
        ) {
          next({ name: 'booster__register' });
          return;
        }

        next();
      },
      component: () => import('Root/pages/booster/Booster.vue'),
      redirect: { name: 'booster__dashboard' },
      children: [
        {
          path: 'find',
          name: 'booster__find',
          component: () => import('Root/pages/booster/findOrders/FindOrders.vue'),
        },
        {
          path: 'multi-chat',
          name: 'booster__multi-chat',
          component: () => import('Root/pages/booster/multiChat/MultiChat.vue'),
        },
        {
          path: 'balance',
          name: 'booster__balance',
          component: () => import('Root/pages/booster/balance/Balance.vue'),
        },
        {
          path: 'profile',
          name: 'booster__profile',
          component: () => import('Root/pages/booster/profile/Profile.vue'),
        },
        {
          path: 'bids',
          name: 'booster__bids',
          component: () => import('Root/pages/booster/bids/BidsList.vue'),
        },
        {
          path: 'orders',
          name: 'booster__orders',
          component: () => import('Root/pages/booster/myOrders/MyOrders.vue'),
        },
        {
          path: 'orders/:id',
          name: 'booster__order-progress',
          component: () => import('Root/pages/booster/orderProgress/OrderProgress.vue'),
        },
        {
          path: 'dashboard',
          name: 'booster__dashboard',
          component: () => import('Root/pages/booster/dashboard/Dashboard.vue'),
        },
        {
          path: 'notifications',
          name: 'booster__notifications',
          component: () => import('Root/pages/booster/notifications/Notifications.vue'),
        },
        {
          path: 'currency',
          name: 'booster__currency',
          component: () => import('Root/pages/booster/currency/BoosterCurrency.vue'),
          beforeEnter(to, from, next) {
            const { user, boosterProfile } = getUserInfo();
            if (
              !boosterProfile.is_currency_marketplace_available
              || UserModel.ROLES.PRO_CANDIDATE.id === user.role
            ) {
              next({ name: 'booster__dashboard' });
              return;
            }

            next();
          },
          redirect: { name: 'booster__currency-dashboard' },
          children: [
            {
              path: '',
              name: 'booster__currency-dashboard',
              component: () => import('Root/pages/booster/currency/offers/BoosterCurrencyDashboard.vue'),
            },
            {
              path: 'offers/:id?',
              name: 'booster__currency-offers',
              component: () => import('Root/pages/booster/currency/offers/BoosterCurrencyOffers.vue'),
            },
            {
              path: 'games',
              name: 'booster__currency-games',
              component: () => import('Root/pages/booster/currency/offers/BoosterCurrencyGames.vue'),
            },
          ],
        },
        {
          path: 'accounts',
          name: 'booster__accounts',
          component: () => import('Root/pages/booster/accounts/BoosterAccounts.vue'),
          beforeEnter(to, from, next) {
            const { user, boosterProfile } = getUserInfo();
            if (
              !boosterProfile.is_accounts_marketplace_available
              || UserModel.ROLES.PRO_CANDIDATE.id === user.role
            ) {
              next({ name: 'booster__dashboard' });
              return;
            }

            next();
          },
          redirect: { name: 'booster__accounts-dashboard' },
          children: [
            {
              path: '',
              name: 'booster__accounts-dashboard',
              component: () => import('Root/pages/booster/accounts/offers/BoosterAccountsDashboard.vue'),
            },
            {
              path: 'offers/:id?',
              name: 'booster__accounts-offers',
              component: () => import('Root/pages/booster/accounts/offers/BoosterAccountsOffers.vue'),
            },
            {
              path: 'games',
              name: 'booster__accounts-games',
              component: () => import('Root/pages/booster/currency/offers/BoosterCurrencyGames.vue'),
            },
            {
              path: 'offers/edit/:offerId?',
              name: 'booster__accounts-offer-edit',
              component: () => import('Root/pages/booster/accounts/offers/BoosterAccountsOffer.vue'),
            },
            {
              path: 'offers/create/:currencySettingId?',
              name: 'booster__accounts-offer-create',
              component: () => import('Root/pages/booster/accounts/offers/BoosterAccountsOffer.vue'),
            },
          ],
        },
        {
          path: 'legal',
          name: 'booster__legal',
          component: () => import('Root/pages/booster/legal/Legal.vue'),
          redirect: { name: 'booster__rules' },
          children: [
            {
              path: 'faq',
              name: 'booster__faq',
              component: () => import('Root/pages/booster/legal/FAQ.vue'),
            },
            {
              path: 'rules',
              name: 'booster__rules',
              component: () => import('Root/pages/booster/legal/Rules.vue'),
            },
            {
              path: 'policy',
              name: 'booster__policy',
              component: () => import('Root/pages/booster/legal/Policy.vue'),
            },
            {
              path: 'marketplaceFAQ',
              name: 'booster__marketplace-faq',
              component: () => import('Root/pages/booster/legal/MarketplaceFAQ.vue'),
              beforeEnter(to, from, next) {
                const { boosterProfile } = getUserInfo();
                if (!boosterProfile.is_currency_marketplace_available) {
                  next({ name: 'booster__faq' });
                  return;
                }

                next();
              },
            },
            {
              path: 'marketplaceRating',
              name: 'booster__marketplace-rating',
              component: () => import('Root/pages/booster/legal/MarketplaceSellerRating.vue'),
              beforeEnter(to, from, next) {
                const { boosterProfile } = getUserInfo();
                if (!boosterProfile.is_currency_marketplace_available) {
                  next({ name: 'booster__faq' });
                  return;
                }

                next();
              },
            },
          ],
        },
      ],
    },
    {
      path: '/pro/register',
      name: 'booster__register',
      component: () => import('Root/pages/booster/register/BoosterRegister.vue'),
      beforeEnter(to, from, next) {
        const { boosterProfile, user } = getUserInfo();

        const isManager = user
          && [
            UserModel.ROLES.ADMIN.id,
            UserModel.ROLES.SALES_MANAGER.id,
            UserModel.ROLES.SUPPLY_MANAGER.id,
            UserModel.ROLES.PROJECT_MANAGER.id,
          ].includes(user.role);

        if (isManager) {
          next('/');
          return;
        }

        const isValidBoosterProfile = boosterProfile
          && [BoosterProfileModel.STATUSES.APPROVED.id, BoosterProfileModel.STATUSES.WAITING_FOR_APPROVE.id]
            .includes(boosterProfile.status_id);

        if (isValidBoosterProfile) {
          next({ name: 'booster' });
          return;
        }

        next();
      },
      redirect: { name: 'booster-register__step:account' },
      children: [
        {
          path: 'account',
          name: 'booster-register__step:account',
          component: () => import('Root/pages/booster/register/steps/RegisterStepAccount.vue'),
        },
        {
          path: 'personal',
          name: 'booster-register__step:personal',
          component: () => import('Root/pages/booster/register/steps/RegisterStepPersonal.vue'),
        },
        {
          path: 'games',
          name: 'booster-register__step:games',
          component: () => import('Root/pages/booster/register/steps/RegisterStepGames.vue'),
        },
        {
          path: 'verification',
          name: 'booster-register__step:verification',
          component: () => import('Root/pages/booster/register/steps/RegisterStepVerification.vue'),
        },
        {
          path: 'rules',
          name: 'booster-register__step:rules',
          component: () => import('Root/pages/booster/register/steps/RegisterStepRules.vue'),
        },
      ],
    },
  ];
}
